// @flow

import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontNormal } from "@fdr/static-ui/Typography";

export const PayoffRow = styled.li`
  background-color: ${buildColor("white", "100")};
  display: flex;
  flex-direction: column;
  padding: 12px 16px 12px 0;
  margin-left: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid ${buildColor("grey", "L2")};
  }
`;

export const PayoffInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PayOffValue = styled.span`
  font-size: 14px;
  color: ${buildColor("grey", "D4")};
  font-family: ${fontNormal};
`;

export const Selections = styled.span`
  font-size: 14px;
  color: ${buildColor("grey", "D4")};
  font-family: ${fontBold};
  font-weight: 500;
  margin-top: 4px;
  word-break: break-word;
`;

export const PayoffInfo = styled.span`
  font-size: 14px;
  color: ${buildColor("grey", "D4")};
  font-family: ${fontNormal};
`;
